var React = require('react');

function FormkitRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"formkit:right"},React.createElement("path",{"id":"Vector","d":"M3.07138 22.5716C2.95896 22.573 2.8475 22.5508 2.74417 22.5065C2.64083 22.4622 2.54791 22.3968 2.47138 22.3145C2.12852 21.9716 2.12852 21.4402 2.47138 21.0973L9.58566 13.983L2.47138 6.88591C2.12852 6.54305 2.12852 6.01162 2.47138 5.66876C2.81423 5.32591 3.34566 5.32591 3.68852 5.66876L11.3857 13.4002C11.7285 13.743 11.7285 14.2745 11.3857 14.6173L3.67138 22.3145C3.49995 22.4859 3.27709 22.5716 3.07138 22.5716Z","fill":"#1C1C28"})));
}

FormkitRight.defaultProps = {"width":"13","height":"28","viewBox":"0 0 13 28","fill":"none"};

module.exports = FormkitRight;

FormkitRight.default = FormkitRight;
